export default "__VITE_ASSET__xXhnIjeq__"